import { computed, Injectable, signal } from '@angular/core';
import { StockMap, StockProduct } from '@pedix-workspace/shared-stock';
import { CartItem } from '@pedix-workspace/utils';

@Injectable({ providedIn: 'root' })
export class StockService {
  products = signal<StockProduct[]>([]);
  cartItems = signal<CartItem[]>([]);
  originalCartItems = signal<CartItem[]>([]);

  stock = computed<StockMap>(
    () => new StockMap(this.products(), this.cartItems(), this.originalCartItems()),
  );
}
